const LAST_SELECTED_ORG_KEY = `lastSelectedOrganisationId`;

export function getLastSelectedOrgId(): string | null {
  try {
    return sessionStorage.getItem(LAST_SELECTED_ORG_KEY);
  }
  catch (e) {
    return null;
  }
}

export function setLastSelectedOrgId(orgId: string) {
  try {
    sessionStorage.setItem(LAST_SELECTED_ORG_KEY, orgId);
  }
  catch (e) {
    // Silently fail if sessionStorage is not available
  }
}
